import { base } from './';
import {
  AdditionCreateType,
  AdditionUpdateType,
  SearchAdditionalQueryType,
} from 'types';

const PATH = '/additional';

const get = (id: string) => base.get(`${PATH}/${id}`);

const getAll = (filter: SearchAdditionalQueryType) =>
  base.get(PATH, { params: { ...filter } });

const post = (data: AdditionCreateType) => base.post(PATH, data);

const patch = ({ id, ...data }: AdditionUpdateType) =>
  base.patch(`${PATH}/${id}`, data);

export { get, getAll, post, patch };
